<template>
  <div>
    <v-list-group :value="false" color="info">
      <template #activator>
        <v-list-item-title>Workspaces</v-list-item-title>
      </template>
      <v-list-item v-for="workspace in workspaces" :key="workspace.code" link :class="{ active : workspace.code == currentWorkspace.code}" @click="changeCurrentWorkspace(workspace)">
        <v-list-item-title v-text="workspace.name" />
      </v-list-item>
    </v-list-group>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api';
import store from '@/store';
import { changeWorkspace } from '@/helpers/utils';

export default {
  setup () {
    const workspaces = computed(() => store.getters.allowedWorkspaces);

    const currentWorkspace = computed(() => store.state.workspace);

    const changeCurrentWorkspace = async workspace => {
      await changeWorkspace(workspace);
    };

    return { workspaces, changeCurrentWorkspace, currentWorkspace };
  }
};
</script>
